import React from "react";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../../components/ButtonIcon/ButtonIcon";
import CaretRight from "../../../../../../../assets/svg/icons/common/CaretRight";
import Row from "./Row";
import SkeletonRow from "../../../../../../../components/skeleton-loader/table/row";

function ChargebackDataTable({ data = [], loading }) {
  // Ensure data is always an array
  const tableData = Array.isArray(data) ? data : [];

  return (
    <div className={style.batch_table_container}>
      <table className={style.batch_table}>
        <thead>
          <tr className={style.header_row}>
            <th className={style.header_cell}></th>
            <th className={style.header_cell}>Card</th>
            <th className={style.header_cell}>Auth. number</th>
            <th className={style.header_cell}>Cb Amount</th>
            <th className={style.header_cell}>CB Date</th>
            <th className={style.header_cell}>Last action</th>
            <th className={style.header_cell}>Age</th>
            <th className={style.header_cell}>to rebut</th>
            <th className={style.header_cell}>Reason</th>
            <th className={style.header_cell}>Represented</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            Array.from({ length: 10 }).map((_, index) => (
              <SkeletonRow
                key={`batch-data-skeleton-row-${index}`}
                columnLength={9}
                withBlankFirstRow
              />
            ))
          ) : tableData.length === 0 ? (
            <tr>
              <td colSpan="10" className={style.no_data}>
                No data to display
              </td>
            </tr>
          ) : (
            tableData.map((row, index) => <Row data={row} key={index} />)
          )}
        </tbody>
      </table>
    </div>
  );
}

export default ChargebackDataTable;
